import React from 'react';
import { Link } from 'react-router-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors } from 'constants/colors';
export default function Button(props) {
    const { isActive = true, type, width = 304, height = 112, inPercent = false, fontSize = 40, marginBottom = 0, noShadow = false, underline = false, text, transparent, onClick, link, } = props;
    return isWhiteButton(type) ? (React.createElement(WhiteButton, { width: width, height: height, inPercent: inPercent, marginBottom: marginBottom, noShadow: noShadow, fontSize: fontSize, onClick: onClick, "data-active": isActive }, link ? React.createElement(StyledLink, { to: link }, text) : React.createElement(TextWrap, null, text))) : isBlueButton(type) ? (transparent ? (React.createElement(BlueTransparentButton, { width: width, height: height, inPercent: inPercent, marginBottom: marginBottom, fontSize: fontSize, onClick: onClick, "data-active": isActive }, link ? React.createElement(StyledLink, { to: link }, text) : React.createElement(TextWrap, null, text))) : (React.createElement(BlueButton, { width: width, height: height, inPercent: inPercent, marginBottom: marginBottom, noShadow: noShadow, fontSize: fontSize, onClick: onClick, "data-active": isActive }, link ? React.createElement(StyledLink, { to: link }, text) : React.createElement(TextWrap, null, text)))) : isRedButton(type) ? (React.createElement(RedButton, { width: width, height: height, inPercent: inPercent, marginBottom: marginBottom, noShadow: noShadow, fontSize: fontSize, onClick: onClick, "data-active": isActive }, link ? React.createElement(StyledLink, { to: link }, text) : React.createElement(TextWrap, null, text))) : isGreenButton(type) ? (React.createElement(GreenButton, { width: width, height: height, inPercent: inPercent, marginBottom: marginBottom, noShadow: noShadow, fontSize: fontSize, onClick: onClick, "data-active": isActive }, link ? React.createElement(StyledLink, { to: link }, text) : React.createElement(TextWrap, null, text))) : isTransparentButton(type) ? (React.createElement(TransparentButton, { width: width, height: height, inPercent: inPercent, marginBottom: marginBottom, noShadow: noShadow, underline: underline, fontSize: fontSize, onClick: onClick, "data-active": isActive }, link ? React.createElement(StyledLink, { to: link }, text) : React.createElement(TextWrap, null, text))) : null;
}
const isWhiteButton = (type) => type === 'white';
const isBlueButton = (type) => type === 'blue';
const isRedButton = (type) => type === 'red';
const isGreenButton = (type) => type === 'green';
const isTransparentButton = (type) => type === 'transparent';
const StyledButton = styled.button `
  appearance: none;
  cursor: pointer;
  width: ${(props) => props.width}${(props) => (props.inPercent ? '%' : 'px')};
  height: ${(props) => props.height}${(props) => (props.inPercent ? '%' : 'px')};
  margin-bottom: ${(props) => props.marginBottom}px;
  padding: 0px;
  outline: none;
  border: none;
  border-radius: 8px;
  background-color: ${(props) => props.defaultBackground};
  box-shadow: none;
  font-size: ${(props) => props.fontSize}px;
  font-weight: 500;
  letter-spacing: 0px;
  text-align: center;
  color: ${(props) => props.textColor};
  text-decoration: ${(props) => (props.underline ? 'underline' : 'none')};

  &[data-active='false'] {
    pointer-events: none;
    opacity: 0.4;
    box-shadow: none;
  }

  &:active {
    background-color: ${(props) => props.activeBackground};
  }
`;
const WhiteButton = styled(StyledButton) `
  background-color: ${colors.ffffff};

  & > a,
  & > div {
    color: ${colors['138efd']};
  }

  &:active {
    background-color: ${colors.dceeff};
  }
`;
const BlueButton = styled(StyledButton) `
  background-color: ${colors['3269f5']};
`;
const BlueTransparentButton = styled.button `
  background-color: ${colors.sailBlue};
  border-radius: 8px;
  border: 2px solid ${colors.sailBlue};
  color: ${colors.sailBlue};
  cursor: pointer;
  font-size: ${(props) => props.fontSize}px;
  font-weight: normal;
  height: ${(props) => props.height}${(props) => (props.inPercent ? '%' : 'px')};
  letter-spacing: 0px;
  margin-bottom: ${(props) => props.marginBottom}px;
  outline: none;
  padding: 0px;
  text-align: center;
  width: ${(props) => props.width}${(props) => (props.inPercent ? '%' : 'px')};
`;
const RedButton = styled(StyledButton) `
  background-image: linear-gradient(112deg, ${colors.ff6169}, ${colors.ff6e7a});
  box-shadow: ${colors['065580bf']};
  color: ${colors.ffffff};
  &:active {
    background-image: linear-gradient(${colors['00000026']}, ${colors['00000026']}),
      linear-gradient(112deg, ${colors.ff6169}, ${colors.ff6e7a});
  }
`;
const GreenButton = styled(StyledButton) `
  background-image: linear-gradient(106deg, ${colors['35d46a']}, ${colors['33d489']});
  box-shadow: ${colors['065580bf']};
  color: ${colors.ffffff};
  &:active {
    background-image: linear-gradient(${colors['00000026']}, ${colors['00000026']}),
      linear-gradient(106deg, ${colors['35d46a']}, ${colors['33d489']});
  }
`;
const TransparentButton = styled(StyledButton) `
  background-color: inherit;
  color: ${colors.ffffff};
`;
const textWrapStyle = css `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: ${colors.ffffff};
  white-space: pre-wrap;
  line-height: 1.3;
`;
const StyledLink = styled(Link) `
  ${textWrapStyle};
`;
const TextWrap = styled.div `
  ${textWrapStyle};
`;
